
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '院區名稱',
    model: 'name',
    placeholder: '院區名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '所屬地區',
    model: 'district_id',
    required: true,
    help: "用於「看診進度 - 院所列表」",
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-district-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '代表色(文字)',
    model: 'text_color',
    placeholder: '代表色(文字)',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '代表色(色塊)',
    model: 'bg_color',
    placeholder: '代表色(色塊)',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '代表色',
    model: 'color',
    placeholder: '代表色',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  // {
  //   type: 'bsx-select',
  //   label: '代表色',
  //   model: 'color',
  //   required: true,
  //   values() {
  //     return [
  //       { 'id': "pink", 'name': "粉紅" },
  //       { "id": "purple", "name": "粉紫" },
  //       { "id": "green", "name": "淺綠" }
  //     ];
  //   },
  //   validator: function () {
  //     this.validation();
  //   },
  // },
  {
    type: "x-QuillEditor",
    label: "院區須知",
    model: "intro",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序權重",
    hint: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
